import React, { useEffect } from "react";
import { Outlet, useLocation } from 'react-router-dom';
import "../../App.css";
import {Header} from "./Header";
import {Footer} from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { getAppTheme } from "../../theme";

export const Layout = (props) => {
    const location = useLocation();
    const isAppRoute = location.pathname.startsWith("/portal");
    const appTheme = getAppTheme();
    const showFooter = !isAppRoute && appTheme !== "lion";

    useEffect(() => {
        document.body.classList.remove("theme-lion", "theme-classic");
        document.body.classList.toggle(`theme-${appTheme}`, Boolean(appTheme));
        document.body.classList.toggle("portalAppShell", isAppRoute);

        return () => {
            document.body.classList.remove(`theme-${appTheme}`);
            document.body.classList.remove("portalAppShell");
        };
    }, [appTheme, isAppRoute]);

    return (
        <>
            <ScrollToTop />
            <Header appTheme={appTheme} />
            <Outlet context={{ appTheme }} />
            {showFooter && <Footer />}
        </>
    );
};
